export class SendStudentFeedbackLinkModalData {
    public studentId: number;
    public studentName: string;
    public placementId: number;
    public placementStartDate: Date;
    public placementEndDate: Date;
    public showEmailButton: boolean;

    constructor() {}
}